(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag-collection"]) return;
  try {
    
if (!window.__agCollSortBound) {
  window.__agCollSortBound = true;
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ag-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
}
if (!window.__agCollFilterBound) {
  window.__agCollFilterBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ag-filter]');
    if (!btn) return;
    var root = btn.closest('.ag-coll');
    if (!root) return;
    root.querySelectorAll('[data-ag-filter]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var f = btn.getAttribute('data-ag-filter') || '';
    var visible = 0;
    root.querySelectorAll('.ag-coll__card').forEach(function (card) {
      var cols = ' ' + (card.getAttribute('data-ag-cols') || '') + ' ';
      var show = f === '' || cols.indexOf(' ' + f + ' ') !== -1;
      card.classList.toggle('is-filtered', !show);
      if (show) visible++;
    });
    var empty = root.querySelector('[data-ag-filter-empty]');
    if (empty) empty.hidden = visible > 0;
    var count = root.querySelector('[data-ag-count]');
    if (count) count.textContent = visible + ' producten';
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-featured-product"] && !Shopify.designMode) return;
  try {
    
if (!window.__agFeatpBound) {
  window.__agFeatpBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ag-featp-add]');
    if (!btn || btn.dataset.agBusy === '1') return;
    var id = Number(btn.getAttribute('data-ag-featp-add'));
    if (!id) return;
    btn.dataset.agBusy = '1';
    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function () {
        var original = btn.textContent;
        btn.classList.add('is-added');
        btn.textContent = btn.getAttribute('data-ag-added-text') || '✓ Toegevoegd';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.requestUpdate === 'function') drawer.requestUpdate();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = original;
          delete btn.dataset.agBusy;
        }, 1600);
      })
      .catch(function () { delete btn.dataset.agBusy; });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-packages"] && !Shopify.designMode) return;
  try {
    
if (!window.__agAtcBound) {
  window.__agAtcBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ag-atc]');
    if (!btn || btn.disabled) return;
    var id = btn.dataset.agVariant;
    if (!id) return;
    var routes = (window.Theme && window.Theme.routes) || {};
    var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
    var original = btn.textContent;
    btn.disabled = true;
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: id, quantity: 1 }),
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        btn.textContent = btn.dataset.agAddedText || 'Toegevoegd ✓';
        var live = document.querySelector('[data-ag-cart-live]');
        if (live) live.textContent = btn.dataset.agAddedText || 'Toegevoegd aan winkelwagen';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.requestUpdate === 'function') drawer.requestUpdate();
      })
      .catch(function () { btn.textContent = 'Er ging iets mis'; })
      .finally(function () {
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-pill-header"]) return;
  try {
    
if (!window.__agPillInit) {
  window.__agPillInit = true;

  var agPillEach = function (fn) {
    document.querySelectorAll('[data-ag-pillhdr]').forEach(fn);
  };

  var agFindScroller = function (el) {
    var node = el && el.parentElement;
    while (node && node !== document.documentElement) {
      var cs = getComputedStyle(node);
      if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
      node = node.parentElement;
    }
    return null;
  };

  var agScrollPos = function (hdr) {
    return hdr.__agScroller ? hdr.__agScroller.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0);
  };

  var agPillMeasure = function () {
    agPillEach(function (hdr) {
      var section = hdr.closest('.shopify-section') || hdr.parentElement;
      var wasFloating = hdr.classList.contains('is-floating');
      hdr.classList.remove('is-floating');
      hdr.__agScroller = agFindScroller(section);
      if (section) {
        section.style.minHeight = '';
        section.style.minHeight = hdr.offsetHeight + 'px';
        var rect = section.getBoundingClientRect();
        var refTop = hdr.__agScroller ? hdr.__agScroller.getBoundingClientRect().top : 0;
        hdr.__agThreshold = rect.top - refTop + agScrollPos(hdr) + 8;
      } else {
        hdr.__agThreshold = 12;
      }
      if (wasFloating) hdr.classList.add('is-floating');
    });
  };

  var agPillScroll = function () {
    agPillEach(function (hdr) {
      var t = typeof hdr.__agThreshold === 'number' ? hdr.__agThreshold : 12;
      hdr.classList.toggle('is-floating', agScrollPos(hdr) > t);
    });
  };

  var agCloseAllMegas = function (hdr) {
    hdr.querySelectorAll('[data-ag-mega]').forEach(function (item) {
      var p = item.querySelector('.ag-pillhdr__mega');
      if (p) p.hidden = true;
      item.classList.remove('is-open');
    });
  };

  var agPillBind = function () {
    agPillEach(function (hdr) {
      if (hdr.__agBound) return;
      hdr.__agBound = true;

      var toggle = hdr.querySelector('[data-ag-menu-toggle]');
      var panel = hdr.querySelector('[data-ag-mobile-menu]');
      if (toggle && panel) {
        var agCloseMenu = function () {
          toggle.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        };
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });
        panel.addEventListener('click', function (e) {
          if (e.target.closest('a')) agCloseMenu();
        });
        document.addEventListener('click', function (e) {
          if (!panel.hidden && !hdr.contains(e.target)) agCloseMenu();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            if (!panel.hidden) { agCloseMenu(); toggle.focus(); }
            agCloseAllMegas(hdr);
          }
        });
      }

      hdr.querySelectorAll('[data-ag-sub-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sub = btn.nextElementSibling;
          if (!sub) return;
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          sub.hidden = open;
        });
      });

      hdr.querySelectorAll('[data-ag-mega]').forEach(function (item) {
        var mega = item.querySelector('.ag-pillhdr__mega');
        if (!mega) return;
        var closeTimer;
        var openMega = function () {
          clearTimeout(closeTimer);
          agCloseAllMegas(hdr);
          mega.hidden = false;
          item.classList.add('is-open');
        };
        var closeMega = function () {
          closeTimer = setTimeout(function () {
            mega.hidden = true;
            item.classList.remove('is-open');
          }, 130);
        };
        item.addEventListener('mouseenter', openMega);
        item.addEventListener('mouseleave', closeMega);
        item.addEventListener('focusin', openMega);
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) closeMega();
        });
      });
    });
    agPillMeasure();
    agPillScroll();
  };

  var agPillCount = function () {
    var routes = (window.Theme && window.Theme.routes) || {};
    fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-ag-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.classList.toggle('is-empty', !c.item_count);
        });
      })
      .catch(function () {});
  };

  var agPillResizeTimer;
  document.addEventListener('scroll', agPillScroll, { capture: true, passive: true });
  window.addEventListener('resize', function () {
    clearTimeout(agPillResizeTimer);
    agPillResizeTimer = setTimeout(agPillMeasure, 150);
  });
  ['cart:refresh', 'cart:update', 'cart:change', 'CartUpdateEvent'].forEach(function (ev) {
    document.addEventListener(ev, agPillCount);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agPillBind);
  } else {
    agPillBind();
  }
  window.addEventListener('load', agPillMeasure);
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-ag-pillhdr]').forEach(function (hdr) { hdr.__agBound = false; });
    agPillBind();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-video-proof"] && !Shopify.designMode) return;
  try {
    
if (!window.__agVpBound) {
  window.__agVpBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ag-vp-play]');
    if (!btn) return;
    var media = btn.closest('.ag-vp__media');
    var video = media && media.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.ag-vp__media video').forEach(function (v) {
      if (v !== video) v.pause();
    });
    btn.classList.add('is-hidden');
    video.setAttribute('controls', 'controls');
    video.play();
    video.addEventListener('ended', function () {
      btn.classList.remove('is-hidden');
      video.removeAttribute('controls');
    }, { once: true });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wcshield-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHowSlider() {
    document.querySelectorAll('[data-wc-how-slider]').forEach(function (grid) {
      if (grid.dataset.wcInit === '1') return;
      grid.dataset.wcInit = '1';
      var root = grid.closest('.wcshield-how');
      var dotsWrap = root && root.querySelector('.wcshield-how__dots');
      var cards = grid.querySelectorAll('.wcshield-how__card');
      if (!dotsWrap || cards.length < 2) return;
      dotsWrap.innerHTML = '';
      var dots = [];
      cards.forEach(function (_, i) {
        var d = document.createElement('span');
        d.className = 'wcshield-how__dot' + (i === 0 ? ' is-active' : '');
        dotsWrap.appendChild(d);
        dots.push(d);
      });
      var update = function () {
        var max = grid.scrollWidth - grid.clientWidth;
        if (max <= 0) return;
        var i = Math.round((grid.scrollLeft / max) * (dots.length - 1));
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      };
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }
  if (document.readyState !== 'loading') initHowSlider();
  else document.addEventListener('DOMContentLoaded', initHowSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wcshield-order-bump"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const row = e.target.closest('[data-wc-bump]');
  if (!row) return;
  const id = row.dataset.wcVariant;
  if (!id) return;
  const isOn = row.getAttribute('aria-pressed') === 'true';
  const routes = (window.Theme && window.Theme.routes) || {};
  const addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  const changeUrl = (routes.cart_change_url || '/cart/change') + '.js';
  const url = isOn ? changeUrl : addUrl;
  const payload = isOn ? { id: id, quantity: 0 } : { id: id, quantity: 1 };
  row.setAttribute('aria-disabled', 'true');
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  })
    .then((r) => r.json())
    .then(() => {
      const next = !isOn;
      row.setAttribute('aria-pressed', next ? 'true' : 'false');
      row.classList.toggle('is-on', next);
      const live = row.closest('.wcshield-bump__inner').querySelector('.wcshield-bump__live');
      if (live) live.textContent = next ? 'Toegevoegd aan winkelwagen' : 'Verwijderd uit winkelwagen';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (window.Shopify && window.Shopify.designMode) return;
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.requestUpdate === 'function') drawer.requestUpdate();
    })
    .catch(() => {})
    .finally(() => row.removeAttribute('aria-disabled'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wcshield-product-hero"] && !Shopify.designMode) return;
  try {
    
class WcshieldGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-wc-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-wc-thumb]'));
    this.index = 0;
    const prev = this.querySelector('[data-wc-prev]');
    const next = this.querySelector('[data-wc-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
    if (next) next.addEventListener('click', () => this.go(this.index + 1));
    this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(parseInt(t.dataset.wcThumb, 10))));
  }
  go(i) {
    if (!this.slides.length) return;
    const n = this.slides.length;
    this.index = ((i % n) + n) % n;
    this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.index));
    this.thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === this.index));
  }
}
if (!customElements.get('wcshield-gallery')) customElements.define('wcshield-gallery', WcshieldGallery);

class WcshieldTabs extends HTMLElement {
  connectedCallback() {
    this.btns = Array.from(this.querySelectorAll('[data-wc-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-wc-panel]'));
    this.btns.forEach((b) => b.addEventListener('click', () => this.show(b.dataset.wcTab)));
  }
  show(name) {
    this.btns.forEach((b) => {
      const on = b.dataset.wcTab === name;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.panels.forEach((p) => {
      const on = p.dataset.wcPanel === name;
      p.classList.toggle('is-active', on);
      if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
    });
  }
}
if (!customElements.get('wcshield-tabs')) customElements.define('wcshield-tabs', WcshieldTabs);

document.addEventListener('click', (e) => {
  const tier = e.target.closest('[data-wc-tier]');
  if (!tier) return;
  const form = tier.closest('form');
  const group = tier.closest('.wcshield-tiers');
  if (!group) return;
  group.querySelectorAll('[data-wc-tier]').forEach((b) => {
    const on = b === tier;
    b.classList.toggle('is-selected', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  const qtyInput = form && form.querySelector('[data-wc-quantity]');
  if (qtyInput) qtyInput.value = tier.dataset.wcTierQty || '1';
});

// Auto-add the free gift product before the main add-to-cart submission.
// Runs in capture phase so it executes before the theme's own click/submit handlers.
document.addEventListener(
  'click',
  (e) => {
    const btn = e.target.closest('button[type="submit"][name="add"]');
    if (!btn) return;
    const form = btn.closest('form[data-type="add-to-cart-form"]');
    if (!form || !form.querySelector('.wcshield-tiers')) return;
    if (form.dataset.wcGiftPending === '1') {
      delete form.dataset.wcGiftPending;
      return;
    }
    const selected = form.querySelector('[data-wc-tier].is-selected');
    const giftId = selected && selected.dataset.wcGiftVariant;
    if (!giftId) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(giftId), quantity: 1 }] }),
    })
      .catch(() => {})
      .finally(() => {
        form.dataset.wcGiftPending = '1';
        btn.click();
      });
  },
  true
);

document.addEventListener('change', (e) => {
  const sel = e.target.closest('[data-wc-variant-select]');
  if (!sel) return;
  const form = sel.closest('form');
  if (!form) return;
  const idInput = form.querySelector('[data-wc-variant-id]');
  if (idInput) idInput.value = sel.value;
  const opt = sel.options[sel.selectedIndex];
  const info = form.closest('.wcshield-hero__info');
  const priceEl = info && info.querySelector('[data-wc-price]');
  if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wcshield-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStickyAtc() {
    var bar = document.querySelector('.wcshield-sticky');
    if (!bar || bar.dataset.wcInit === '1') return;
    var target =
      document.querySelector('.wcshield-hero .wcshield-atc__button') ||
      document.querySelector('.wcshield-hero .wcshield-atc');
    if (!target) return;
    bar.dataset.wcInit = '1';
    var update = function () {
      var r = target.getBoundingClientRect();
      // Show as soon as the static add-to-cart button has scrolled above the viewport.
      if (r.bottom <= 0) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function () { update(); }, { threshold: [0, 1] });
      io.observe(target);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
  if (document.readyState !== 'loading') initStickyAtc();
  else document.addEventListener('DOMContentLoaded', initStickyAtc);

  // Scroll back to the quantity-break options when the sticky button is clicked.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wc-sticky-scroll]');
    if (!btn) return;
    var target =
      document.querySelector('.wcshield-hero .wcshield-tiers') ||
      document.querySelector('.wcshield-hero .wcshield-atc') ||
      document.querySelector('.wcshield-hero');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wcshield-tools"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wc-tool-add]');
  if (!btn || btn.dataset.wcBusy === '1') return;
  const variantId = Number(btn.dataset.wcToolAdd);
  if (!variantId) return;
  btn.dataset.wcBusy = '1';
  const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
  fetch(addUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then(() => {
      const original = btn.textContent;
      btn.classList.add('is-added');
      btn.textContent = btn.dataset.wcAddedText || '✓ Toegevoegd';
      const dlg = btn.closest('dialog');
      setTimeout(() => {
        btn.classList.remove('is-added');
        btn.textContent = original;
        delete btn.dataset.wcBusy;
        if (dlg && dlg.open) dlg.close();
      }, 1400);
    })
    .catch(() => { delete btn.dataset.wcBusy; });
});

// Product info popup: open on card click, close via button / backdrop / Esc.
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-wc-tool-add]')) return;
  const closeBtn = e.target.closest('[data-wc-modal-close]');
  if (closeBtn) {
    const dlg = closeBtn.closest('dialog');
    if (dlg) dlg.close();
    return;
  }
  const backdrop = e.target.closest('dialog.wcshield-tool-modal');
  if (backdrop && e.target === backdrop) {
    // Ignore stray clicks that land on the backdrop right after opening.
    if (Date.now() - Number(backdrop.dataset.wcOpenedAt || 0) > 300) backdrop.close();
    return;
  }
  const opener = e.target.closest('[data-wc-tool-open]');
  if (opener) {
    const dlg = document.getElementById('wc-tool-modal-' + opener.dataset.wcToolOpen);
    if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
      dlg.dataset.wcOpenedAt = Date.now();
      dlg.showModal();
    }
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  const opener = e.target.closest && e.target.closest('[data-wc-tool-open]');
  if (!opener) return;
  e.preventDefault();
  const dlg = document.getElementById('wc-tool-modal-' + opener.dataset.wcToolOpen);
  if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
    dlg.dataset.wcOpenedAt = Date.now();
    dlg.showModal();
  }
});

  } catch(e) { console.error(e); }
})();
})();
